import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { GasTwo } from '../models/gastwo.model';
import { AuthService } from '../services/auth.service';
import { ConfigurationService } from '../services/configuration.service';

@Injectable()
export class GasTwoService {
    private _authService: AuthService;

    constructor(private http: HttpClient, private injector: Injector) { }

    private get authService() {
        if (!this._authService)
            this._authService = this.injector.get(AuthService);

        return this._authService;
    }

    get() {
        return this.http.get('api/GasTwo', this.getAuthHeader(true));
    }

    getDataListByPage(page: number, pagesize: number, orderBy: string, isDesc: boolean, search?: string) {
        if (search != null && search !== '') {
            return this.http.get(`api/GasTwo/GetDataListByPage/${page}/${pagesize}/${orderBy}/${isDesc}/${search}`, this.getAuthHeader(true));
        }
        return this.http.get(`api/GasTwo/GetDataListByPage/${page}/${pagesize}/${orderBy}/${isDesc}`, this.getAuthHeader(true));
    }

    createUpdate(gastwo: GasTwo) {
        return this.http.post('api/GasTwo', gastwo, this.getAuthHeader(true));
    }

    getLastUpdateDate() {
        return this.http.get('api/GasTwo/GetLastUpdateDate', this.getAuthHeader(true));
    }

    getStatistics(monthsCount: number) {
        return this.http.get('api/GasTwo/GetStatistics/' + monthsCount, this.getAuthHeader(true));
    }

    getCacheStatistics(monthsCount: number) {
        return this.http.get('api/GasTwo/getCacheStatistics/' + monthsCount, this.getAuthHeader(true));
    }

    getGasTwoById(id: number) {
        return this.http.get(`api/GasTwo/GetById/${id}`, this.getAuthHeader(true));
    }

    delete(id: number) {
        return this.http.get(`api/GasTwo/Delete/${id}`, this.getAuthHeader(true));
    }

    public getAuthHeader(includeJsonContentType?: boolean) {
        let headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.authService.accessToken });

        if (includeJsonContentType)
            headers.append("Content-Type", "application/json");

        headers.append("Accept", 'application/json');
        headers.append("App-Version", ConfigurationService.appVersion);

        var options = {
            headers: headers
        };

        return options;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/services/gatwo.service.ts